function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.62132034,12 L17.5606602,19.561276 C18.1464466,20.1191679 18.1464466,21.0236893 17.5606602,21.5815811 C16.9748737,22.139473 16.0251263,22.139473 15.4393398,21.5815811 L6.43933983,13.0101525 C5.85355339,12.4522607 5.85355339,11.5477393 6.43933983,10.9898475 L15.4393398,2.41841888 C16.0251263,1.86052704 16.9748737,1.86052704 17.5606602,2.41841888 C18.1464466,2.97631073 18.1464466,3.88083213 17.5606602,4.43872397 L9.62132034,12 Z"
});

var SvgCaretLeft = function SvgCaretLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCaretLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CaretLeft.9d2ba6e7.svg";
export { ForwardRef as ReactComponent };